import { type ReleasePhaseAttributes } from './generated/ReleasePhaseAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface ReleasePhase extends ReleasePhaseAttributes, IColorAttribute {}

@model
@ColorAttribute()
class ReleasePhase extends ApplicationModel {
  // Start auto-generated
  static typename: 'ReleasePhase' = 'ReleasePhase';
  get typename(): 'ReleasePhase' {
    return 'ReleasePhase';
  }

  static internalTypename: 'ReleasePhase' = 'ReleasePhase';
  get internalTypename(): 'ReleasePhase' {
    return 'ReleasePhase';
  }

  static terminologyName = 'Release phase';

  static filterType = 'ReleasePhaseFilters!';
  static filters = { id: '[ID!]' };

  static fields = {
    color: attr({ readable: true }),
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    endOn: attr({ readable: true }),
    featuresCount: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    progress: attr({ readable: true }),
    projectId: attr({ readable: true }),
    releaseId: attr({ readable: true }),
    startOn: attr({ readable: true }),
    type: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    release: attr.belongsTo({ readable: true, typename: 'Release' }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    childRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    comments: attr.hasMany({ readable: true }),
    features: attr.hasMany({ readable: true }),
    parentRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default ReleasePhase;
